import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Projects.css';

const Projects = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const [filter, setFilter] = useState('all');

  const projectsData = [
    {
      id: 1,
      title: 'chatr',
      description: 'A full-stack social media application with modern UI. Features include user authentication, user profile management, email verification and real-time notification',
      category: 'fullstack',
      demoUrl: 'https://auth-app-frontend-rh30.onrender.com',
      githubUrl: 'https://github.com/8adiq/chatr',
    },
    {
      id: 2,
      title: ' Payment API Gateway Service',
      description: 'A scalable API gateway service created with paystack. Incoprorated with rate limiting, authentication, load balancing, and comprehensive error handling. Built for microservices architecture.',
      category: 'backend',
      demoUrl: 'https://lnkd.in/eABfBvkV',
      githubUrl: 'https://github.com/8adiq/payment-api',
    },
    {
      id: 5,
      title: 'Vivideye Concepts',
      description: 'A static website for a video production company built with React and Tailwind CSS. The website features a modern design, responsive layout, and smooth animations to showcase the company\'s portfolio and services.',
      category: 'frontend',
      demoUrl: 'https://vivideye.vercel.app/',
      githubUrl: 'https://github.com/8adiq/vivideye',
    },
    {
      id: 6,
      title: 'Waste Worth',
      description: 'Lead the backend team to build a robust system for a waste management system. Our system included a comprehensive authentication and user management system, listing and marketplace feature, rewards engine and payment integration.',
      category: 'backend',
      demoUrl: ' https://www.wasteworth.com.ng/',
      githubUrl: 'https://github.com/InternPulse/wasteworth-backend-django',
    }
  ];

  const filters = [
    { key: 'all', label: 'All Projects' },
    { key: 'frontend', label: 'Frontend' },
    { key: 'backend', label: 'Backend' },
    { key: 'fullstack', label: 'Full Stack' }
  ];

  const filteredProjects = filter === 'all' 
    ? projectsData 
    : projectsData.filter(project => project.category === filter);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="projects-page section" id="projects" ref={ref}>
      <div className="container">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.div className="section__header" variants={itemVariants}>
            <h2 className="section__title">Featured Projects</h2>
            <p className="section__subtitle">Some of my recent work</p>
          </motion.div>

          <motion.div className="projects__filters" variants={itemVariants}>
            {filters.map(filterItem => (
              <button
                key={filterItem.key}
                className={`filter__btn ${
                  filter === filterItem.key ? 'filter__btn--active' : ''
                }`}
                onClick={() => setFilter(filterItem.key)}
              >
                {filterItem.label}
              </button>
            ))}
          </motion.div>

          <motion.div 
            className="projects__grid"
            variants={containerVariants}
            layout
          >
            {filteredProjects.map((project, index) => (
              <motion.article
                key={project.id}
                className="project__card"
                variants={itemVariants}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="project__header">
                  <div className="project__links">
                    <a 
                      href={project.demoUrl} 
                      className="project__link"
                      aria-label="View live demo"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                    <a 
                      href={project.githubUrl} 
                      className="project__link"
                      aria-label="View source code"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-github"></i>
                    </a>
                  </div>
                </div>
                <div className="project__content">
                  <h3 className="project__title">{project.title}</h3>
                  <p className="project__description">{project.description}</p>
                </div>
              </motion.article>
            ))}
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default Projects;